export const getVenueUrl = (venueCode: string) => {
  const patronAppUrl = process.env.REACT_APP_PATRON_APPLICATION_URL || window.location.origin.replace('admin', 'order');
  
  return `${patronAppUrl}/?venue=${venueCode}`;
};
